module.exports = __webpack_public_path__ + "static/img/019_TO8_1481.53826a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/019_TO8_1481.jpg
// module id = EeY3
// module chunks = 0